import { useResolve } from "@/tsyringe-hooks/useResolve";
import { observer } from "mobx-react-lite";
import { GameContainerStore, TOKEN_GameContainerStore } from "./GameContainerStore";
import SquareView from "./transient/SquareView";

const GameContainerView = observer(() => {
    const store = useResolve<GameContainerStore>(TOKEN_GameContainerStore);

    return (
        <div className="game-container" onMouseMove={store.handleMouseMove} onTouchMove={store.handleTouchMove}>
            <div
                className="game-grid"
                style={{
                    gridTemplateColumns: `repeat(${store.gridSize}, 1fr)`,
                    gridTemplateRows: `repeat(${store.gridSize}, 1fr)`
                }}
            >
                {store.squareStores && store.squareStores.map((square) => {
                    return <SquareView key={square.id} square={square} />;
                })}
            </div>
        </div>
    );
});
export default GameContainerView;
